"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
if (process.env.BROWSER) {
    require('./index.less');
}
class CommentToggle extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }
    onClick() {
        this.setState({
            isOpen: true,
        });
    }
    render() {
        const { enable = false, count = 0, maxCount = 2 } = this.props;
        const { isOpen } = this.state;
        if (!enable || isOpen || count < maxCount) {
            return React.createElement(React.Fragment, null,
                " ",
                this.props.children);
        }
        return (React.createElement("div", { onClick: this.onClick.bind(this) },
            React.createElement("div", { className: "comment-show-more comment-show-more-hide" }, this.props.children),
            React.createElement("div", { className: "show-more-block", style: { display: 'block' } },
                React.createElement("div", { className: "white-block" }),
                React.createElement("span", { className: "text" },
                    "See all comments\uFF08 ",
                    count,
                    " \uFF09"))));
    }
}
exports.default = CommentToggle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBK0I7QUFHL0IsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLE9BQU8sRUFBRTtJQUN2QixPQUFPLENBQUMsY0FBYyxDQUFDLENBQUM7Q0FDekI7QUFZRCxNQUFxQixhQUFjLFNBQVEsS0FBSyxDQUFDLGFBR2hEO0lBQ0MsWUFBWSxLQUFLO1FBQ2YsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ2IsSUFBSSxDQUFDLEtBQUssR0FBRztZQUNYLE1BQU0sRUFBRSxLQUFLO1NBQ2QsQ0FBQztJQUNKLENBQUM7SUFDTSxPQUFPO1FBQ1osSUFBSSxDQUFDLFFBQVEsQ0FBQztZQUNaLE1BQU0sRUFBRSxJQUFJO1NBQ2IsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVNLE1BQU07UUFDWCxNQUFNLEVBQUUsTUFBTSxHQUFHLEtBQUssRUFBRSxLQUFLLEdBQUcsQ0FBQyxFQUFHLFFBQVEsR0FBRyxDQUFDLEVBQUUsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO1FBQ2hFLE1BQU0sRUFBRSxNQUFNLEVBQUUsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO1FBQzlCLElBQUksQ0FBQyxNQUFNLElBQUksTUFBTSxJQUFJLEtBQUssR0FBRyxRQUFRLEVBQUU7WUFDekMsT0FBTzs7Z0JBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUksQ0FBQztTQUNwQztRQUVELE9BQU8sQ0FDTCw2QkFBSyxPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO1lBQ25DLDZCQUFLLFNBQVMsRUFBQywwQ0FBMEMsSUFDdEQsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQ2hCO1lBQ04sNkJBQUssU0FBUyxFQUFDLGlCQUFpQixFQUFDLEtBQUssRUFBRSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUU7Z0JBQzFELDZCQUFLLFNBQVMsRUFBQyxhQUFhLEdBQU87Z0JBQ25DLDhCQUFNLFNBQVMsRUFBQyxNQUFNOztvQkFBb0IsS0FBSzs4QkFBVSxDQUNyRCxDQUNGLENBQ1AsQ0FBQztJQUNKLENBQUM7Q0FDRjtBQW5DRCxnQ0FtQ0MifQ==